<template>
  <div class="app-container">
    <el-card>
      <div class="back-box">
        <div @click="handleBack">
          <img src="../../../assets/back.png" alt="" />
          <span>返回</span>
        </div>
      </div>
      <div class="title-box"><span class="txt1">基本信息</span></div>
      <el-descriptions>
        <el-descriptions-item label="关卡名称">{{rowItem.name}}</el-descriptions-item>
        <el-descriptions-item label="关卡介绍">{{rowItem.introduce}}</el-descriptions-item>
        <el-descriptions-item label="闯关模式">{{rowItem.type === 1?'考试闯关':'学习闯关'}}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{rowItem.createdTime}}</el-descriptions-item>
        <el-descriptions-item label="状态">{{rowItem.state?'启用':'禁用'}}</el-descriptions-item>
      </el-descriptions>
      <div class="title-box"><span class="txt1">闯关阶段</span></div>
      <div v-for="(item,index) in list" :key="index">
        <div class="mb10 jdbox">第{{index + 1}}阶段</div>
        <template v-if="item.courseSubjectList.length > 0">
          <el-descriptions title="闯关模式" class="mt10"></el-descriptions>
          <el-table :data="item.courseSubjectList">
            <el-table-column label="课程名称" prop="name" align="center" />
            <el-table-column label="课程类型" prop="" align="center">
              <template slot-scope="{row}">
                {{row.type === 1?'图文课程':(row.type === 2?'视频课程':'')}}
              </template>
            </el-table-column>
            <el-table-column label="章节节数" prop="chapterNum" align="center" />
          </el-table>
        </template>
        <template v-if="item.courseScenarioExerciseList.length > 0">
          <el-descriptions title="情景练习" class="mt10"></el-descriptions>
          <el-table :data="item.courseScenarioExerciseList">
            <el-table-column label="问题内容" prop="questionContent" align="center" />
          </el-table>
        </template>
        <el-descriptions class="mt10">
          <el-descriptions-item label="闯关模式">{{item.type === 1?'考试闯关':'学习闯关'}}</el-descriptions-item>
          <el-descriptions-item label="考试达标分数" v-if="item.type === 1">{{item.achievementScore}}</el-descriptions-item>
        </el-descriptions>
      </div>

    </el-card>
  </div>
</template>

<script>
import courseSubjectBarrierStageApi from '@/api/course/courseSubjectBarrierStage'
export default {
  props: ['rowItem'],
  data() {
    return {
      form: null,
      list: []
    }
  },
  created() {
    this.doQueryList()
  },
  methods: {
    doQueryList() {
      this.query = {
        pageNo: 1,
        pageSize: 100,
        barrierId: this.rowItem.id
      }
      this.listLoading = true
      return courseSubjectBarrierStageApi.fetchList(this.query)
        .then(data => {
          this.list = data.data
        }).finally(() => {
          this.listLoading = false
        })
    },
    handleBack() {
      this.$emit('handleShow', '', 1)
    }
  }

}
</script>

<style lang="scss" scoped>
.custom {
  font-size: 14px;
  color: #2e2f3e;
  padding: 20px;
  margin: 10px 0;
  &.bg {
    // border-bottom: 1px solid #CCE2D1
    background-color: #eff8fd;
  }
}
.title-box {
  margin: 10px 24px 15px 0;
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .txt1 {
    font-size: 16px;
    // font-weight: bold;
    color: #000000;
    position: relative;
    padding-left: 5px;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 3px;
      bottom: 0;
      width: 4px;
      background: #5dbde7;
      border-radius: 6px;
    }
  }
  .txt2 {
    font-size: 12px;
    color: #8f8e8e;
    padding-left: 7px;
  }
  .fr {
    float: right;
    font-size: 16px;
    color: #1596cd;
  }
}
.tab-box {
  margin-bottom: 40px;
  span {
    font-size: 16px;
    color: #000000;
    cursor: pointer;
    padding-right: 48px;
    &.active {
      color: #5dbde7;
    }
  }
}
.oppr-btn {
  text-align: right;
  margin-bottom: 20px;
}
.jdbox {
  text-align: center;
  font-size: 14px;
  color: #2e2f3e;
}
</style>
